<template>
  <main id="notAuthenticated">
    <div class="left-side" :class="{ hide: hideLeftSide }">
      <router-view v-slot="{ Component, route }">
        <transition mode="out-in" name="fade">
          <div :key="route.name">
            <component :is="Component" @success="transitionToApp = true" />
          </div>
        </transition>
      </router-view>
    </div>
    <div class="right-side" :class="{ 'full-size': hideLeftSide }">
      <img
        src="@/assets/images/element/lemon.svg"
        alt="Yuzu lemon"
        class="lemon"
      />
      <img
        src="@/assets/images/element/zeste.svg"
        alt="Yuzu zeste"
        class="zeste"
      />
      <img
        src="@/assets/images/element/dots-pattern.svg"
        alt="Yuzu dots pattern"
        class="dots-pattern"
      />
      <Transition mode="out-in" name="fade">
        <Carousel v-if="displayCarousel" />
        <Join v-else-if="isJoinPage" :invitation="state.invitation" />
        <div v-else class="success-wrapper">
          <img
            src="@/assets/images/illustration/register-success.svg"
            alt="Success"
          />
          <h1>Merci de vous être inscrit !</h1>
          <p>
            Vous allez être redirigé vers votre espace personnel, veuillez
            patienter.
          </p>
        </div>
      </Transition>
    </div>
  </main>
</template>

<script setup>
import { reactive, ref, computed, watch, inject } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useCompanyStore } from "@/stores/company.js";
import { useUserStore } from "@/stores/user.js";
import Carousel from "@/components/layout/CarouselSide.vue";
import Join from "@/components/layout/JoinSide.vue";

const crisp = inject("crisp");

const companyStore = useCompanyStore();

const userStore = useUserStore();

const router = useRouter();

const route = useRoute();

const transitionToApp = ref(false);

crisp.session.setSegments(["Recruteur"]);

const state = reactive({
  invitation: {},
});

const displayCarousel = computed(() => {
  return route.name !== "joinCompany" && !transitionToApp.value;
});

const isJoinPage = computed(() => {
  return route.name === "joinCompany" && !transitionToApp.value;
});

const hideLeftSide = computed(() => {
  return transitionToApp.value || state.invitation.has_account;
});

if (isJoinPage.value) {
  if (!route.query.invitation_id) router.push({ name: "loginPage" });

  state.invitation = await companyStore.getMemberInvitation(
    route.query.invitation_id
  );

  if (!state.invitation.email) {
    router.push({ name: "loginPage" });
  }

  userStore.user.email = state.invitation.email;
  userStore.user.company_name = state.invitation.company_name;
}

watch(transitionToApp, async () => {
  await companyStore.getCompanyCredits(companyStore.companies[0].company_id);

  setTimeout(() => {
    router.push({
      name: "home",
      params: { companyId: companyStore.companies[0].company_id },
    });
  }, 5000);
});
</script>
